const titles = Object.freeze({
    PRODUCT:'RPFÁCIL',
    RESTAURAR_CONTRASEÑA: "Restaurar contraseña",
});

export default titles;